export const filterChipStyle = {
  display: "flex",
  height: 44,
  minHeight: 44,
  flexShrink: 0,
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 0,
  paddingBottom: 0,
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "flex-start",
} as const

export const compactFilterChipStyle = {
  display: "flex",
  height: 38,
  minHeight: 38,
  flexShrink: 0,
  paddingLeft: 14,
  paddingRight: 14,
  paddingTop: 0,
  paddingBottom: 0,
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "flex-start",
} as const

export const skillChipStyle = {
  display: "flex",
  height: 40,
  minHeight: 40,
  flexShrink: 0,
  paddingLeft: 14,
  paddingRight: 14,
  paddingTop: 0,
  paddingBottom: 0,
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "flex-start",
} as const

export const compactSkillChipStyle = {
  display: "flex",
  height: 36,
  minHeight: 36,
  flexShrink: 0,
  paddingLeft: 12,
  paddingRight: 12,
  paddingTop: 0,
  paddingBottom: 0,
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "flex-start",
} as const
